/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetConnectWifiIcon32Regular = forwardRef('NetConnectWifiIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M16.001 7a18.5 18.5 0 0 0-13.398 5.742 1 1 0 1 1-1.449-1.38 20.5 20.5 0 0 1 29.693.002 1 1 0 0 1-1.448 1.38A18.5 18.5 0 0 0 16 7Z" }),
        React.createElement("path", { d: "M16 16a9.5 9.5 0 0 0-7.026 3.106 1 1 0 0 1-1.48-1.346 11.5 11.5 0 0 1 17.012 0 1 1 0 0 1-1.48 1.346A9.501 9.501 0 0 0 16 16Z" }),
        React.createElement("path", { d: "M16 27a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" })));
});
